import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  loneActiveFulfillmentPlan: {
    defaultMessage:
      'This shipment is the only active shipment for a linked Order and cannot be deleted. You may choose to Cancel the linked Order then try deleting again.',
    id: 'UfJCcD',
    description:
      'helper text for a disabled button - the shipment is the only shipment associated with a sales order, which prevents deletion',
  },
  hasItems: {
    defaultMessage: 'Cannot delete a shipment with items',
    id: 'rMLgMo',
    description: 'helper text for a disabled button - the presence of items prevents deletion',
  },
  hasSalesOrderItems: {
    defaultMessage: 'Cannot delete a shipment with items from the marketplace order',
    id: 'jEhmm7',
    description: 'helper text for a disabled button - the presence of marketplace order items prevents deletion',
  },
  nonDeletableStatus: {
    defaultMessage:
      "The shipment's status prevents deletion. You can only delete a shipment that is On Hold, Awaiting Shipment, or Awaiting Payment.",
    id: 'djyCgN',
    description: "helper text for a disabled button - the shipment's status prevents deletion",
  },
  unknownDeletionError: {
    defaultMessage:
      'An unknown error occurred and the shipment was not deleted. Please try again later and contact support if the error occurs again.',
    id: 'AAeBNE',
    description:
      'helper text for a disabled button - default error message indicating that the user\'s request to "delete a shipment" failed',
  },
  deleteModalBody: {
    defaultMessage: 'Deleting this shipment cannot be undone. Are you sure you want to delete it?',
    id: 'd2aWCT',
    description: "delete fulfillmentPlan modal - warning message indicating that a user's action is final",
  },
  deleteShipment: {
    defaultMessage: 'Delete shipment',
    id: 'JW6e1H',
    description: 'orderDetails.fulfillmentPlan.delete',
  },
  deleteModalHeader: {
    defaultMessage: 'Delete shipment',
    id: 'fSNhgi',
    description: 'delete fulfillmentPlan modal - title',
  },
});
